module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABGdBTUEAALGPC/xhBQAAAMJJREFUOBFjZFi1ipnh7xcThv9/VRn+M3AxkAMYGb4xMDLfZmDmOcMCMkyXj9/VUkRMj52JmYMc837++/vj+JtXly5/+sjAAnIZyLBkFbUnZkJin8gx8NS7N3xAfXqXP757wATyJshl5BoGcoCZkMgnsO+AZjGR4yJ8ekYNxBc6xMmNhiFx4YRP1WgY4gsd4uSYGICFI6g8gxZBxOlCUwXSCzIDZBYLqKQFFY5ANXpLKCxgQWaxgIptUEkLKhypUQUAAHI0TzxfTjD3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/EmptyCheckBox.png
// module id = 308
// module chunks = 0